import styled from 'styled-components';
import { Link } from 'gatsby';
import { Box } from './';
import { theme } from '../style';

const Wrapper = styled(Box)`
  position: relative;
  overflow-x: hidden;
  max-width: ${theme.breakpoints.lg};
  padding: 0 40px;
  margin: 0 auto;
  height: 100%;

  @media ${theme.devices.sm} {
    padding: 0 20px;
  }
`;

const Image = styled.img`
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};
  max-width: ${({ maxwidth }) => maxwidth};
  max-height: ${({ maxheight }) => maxheight};
  width: ${({ width }) => width};
  height: ${({ height }) => height};

  object-fit: ${({ objectfit }) => objectfit};
  border-radius: ${({ borderradius }) => borderradius};
`;

const Button = styled(Link)`
  display: inline-block;
  background-color: ${({ bgcolor }) => bgcolor};
  color: ${({ color }) => color};
  text-decoration: none;
  text-align: center;
  padding: 10px 20px;
  border: ${({ border }) => border};
  border-radius: 10px;
  box-shadow: ${({ boxshadow }) => boxshadow};

  transition: all 0.2s;

  :hover {
    background-color: ${({ bgcolorhover }) => bgcolorhover};
    color: ${({ colorhover }) => colorhover};
  }
`;

export { Wrapper, Image, Button };
